module.exports = __webpack_public_path__ + "static/media/floor_tom_3.52e11ca7.png";